'use client'

import Image from 'next/image'
import { useMediaQuery } from '@segway/core'

import { Link, useRouter } from '@/i18n/navigation'

import { HelpMeChooseActionButton } from '../HelpMeChooseActionButton'
import { HelpMeChooseItem } from '../types'

import styles from './page.module.css'

type BestSellerHelpMeChooseProps = {
  helpMeChooseItem: HelpMeChooseItem
}

const BestSellerHelpMeChoose = ({ helpMeChooseItem }: BestSellerHelpMeChooseProps) => {
  const router = useRouter()

  const responsive = useMediaQuery()

  const textColor = helpMeChooseItem?.text_color || '#ffffff'

  return (
    <div className={styles.item}>
      <Link
        className={`relative ${responsive && responsive.xl ? 'mr-4' : 'mr-3'} flex h-[408px] w-[306px] flex-col justify-end overflow-hidden rounded-[12px] font-miSansDemiBold450 xl:h-[430px] xl:w-[712px] xl:rounded-[20px]`}
        href={helpMeChooseItem?.link}
        target={helpMeChooseItem?.open_in_new_window === '1' ? '_blank' : '_self'}>
        <div className="relative h-full w-full">
          <Image
            src={
              responsive && responsive.xl ? helpMeChooseItem?.pc_image : helpMeChooseItem?.mob_image
            }
            alt={helpMeChooseItem?.image_alt}
            width={712}
            height={430}
            className="absolute h-[408px] w-[306px] xl:h-[430px] xl:w-[712px]"
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div className="relative flex-col gap-[12px] pb-[24px] pl-[14px] pr-[24px] xl:flex xl:px-[24px]">
          <div
            className="flex flex-col gap-[4px] xl:max-w-[300px]"
            style={{
              color: textColor,
            }}>
            <p className="font-miSansDemiBold450 text-xl xl:text-2xl">{helpMeChooseItem?.title}</p>
            <p className="font-miSansRegular330 text-base xl:font-miSansMedium380 xl:text-base xl:leading-[1.4]">
              {helpMeChooseItem?.description}
            </p>
          </div>
          <div className={responsive && !responsive.xl ? 'mt-[20px]' : ''}>
            <HelpMeChooseActionButton
              className="h-[32px] gap-1 py-[8px]"
              hasArrowIcon={false}
              onClick={() => {
                if (helpMeChooseItem?.open_in_new_window === '1') {
                  window.open(helpMeChooseItem?.link, '_blank')
                } else {
                  router.push(helpMeChooseItem?.link)
                }
              }}>
              <span className="font-miSansDemiBold450 text-[13px] leading-[16px]">
                {helpMeChooseItem?.button_text}
              </span>{' '}
            </HelpMeChooseActionButton>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default BestSellerHelpMeChoose
